import {
  rem, styled
} from 'config/stitches.config'


export const StyledParagraphWithTitleContent = styled('div', {
  'p': {
    fontWeight: '400',
    fontSize: rem(18),
    lineHeight: '120%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '$gray1'
  }
})

export const StyledParagraphWithTitle = styled('div', {
  'h2': {
    fontWeight: '500',
    fontSize: rem(48),
    lineHeight: '100%',
    letterSpacing: '-2%',
  },


  button: {
    all: 'unset',
    fontWeight: '700',
    fontSize: '16px',
    color: '#26376D',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    marginTop: '0.75rem',
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    span: { borderBottom: '2px solid #26376D', },
  }
})

